import goldenstar from "../../../../assests/auth/goldenstar.png";
export const Data =[
    {image:goldenstar,tittle:'Unlimited Access To My School'},
    {image:goldenstar,tittle:'50,000+ Teaching Resources'},
    {image:goldenstar,tittle:'20,000+ Clip Art Illustrations'},
    {image:goldenstar,tittle:'Unlimited Downloads'},
    {image:goldenstar,tittle:'1000+ Educational Videos'},
    {image:goldenstar,tittle:'2500+ Interactive Lessons'},
]